import React from 'react';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';

import Layers, { LAYER_TYPES, SPATIAL_FOR_JOIN_SUBTYPES } from '../../../api/Layers/Layers';
import { isDeleted, getName } from '../../../api/Layers/layer-operations';

import PageHeader from '../../atoms/PageHeader';
import LayerEditor from '../../components/LayerEditor';
import Loading from '../../components/Loading';
import NotFound from '../NotFound';

const EditLayer = ({
  layer,
  history,
  isFree,
  match,
  loading,
  isBasic,
  geojsonLayers,
  thematicLayers,
  deployEnv,
  deployConfig,
  userControlSetting
}) => {
  if (loading) {
    return <Loading />;
  }
  if (isDeleted(layer)) {
    return <NotFound />;
  }
  return (
    <>
      <PageHeader>
        <h4>{`Editing "${getName(layer)}"`}</h4>
      </PageHeader>
      <LayerEditor
        layer={layer}
        history={history}
        match={match}
        isFree={isFree}
        thematicLayers={thematicLayers}
        geojsonLayers={geojsonLayers}
        deployEnv={deployEnv}
        isBasic={isBasic}
        deployConfig={deployConfig}
        userControlSetting={userControlSetting}
      />
    </>
  );
};

EditLayer.defaultProps = {
  layer: {},
  geojsonLayers: [],
  thematicLayers: [],
  userControlSetting: {}
};

EditLayer.propTypes = {
  layer: PropTypes.object,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  deployConfig: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  isFree: PropTypes.bool.isRequired,
  isBasic: PropTypes.bool.isRequired,
  deployEnv: PropTypes.string.isRequired,
  thematicLayers: PropTypes.array,
  geojsonLayers: PropTypes.array,
  userControlSetting: PropTypes.object
};

export default withTracker(({ match }) => {
  const layerId = match.params.layer_id;
  const layerSub = Meteor.subscribe('layers');

  return {
    loading: !layerSub.ready(),
    layer: Layers.findOne(layerId),
    geojsonLayers: Layers.find({
      deleted: { $eq: 'no' },
      layerType: { $eq: LAYER_TYPES.SPATIAL },
      layerSubType: { $in: SPATIAL_FOR_JOIN_SUBTYPES }
    }).fetch(),
    thematicLayers: Layers.find({
      deleted: { $eq: 'no' },
      layerType: { $eq: LAYER_TYPES.THEMATIC }
    }).fetch()
  };
})(EditLayer);
